import { useDesignTokens } from "@boi/react-design-tokens";
import styled, { css } from "styled-components";

export const Wrapper = styled.div`
  display: flex;
`;

type PaddingProps = {
  $location: "left" | "right";
  $sliderPercent: number;
};

export const Padding = styled.div<PaddingProps>`
  ${({ $location, $sliderPercent }) => {
    const flexGrowValue =
      $location == "left" ? $sliderPercent : 100 - $sliderPercent;

    return css`
      flex-grow: ${flexGrowValue};
    `;
  }}
`;

type ContentProps = {
  $isHidden: boolean;
};

export const Content = styled.div<ContentProps>`
  ${({ $isHidden }) => {
    const { tokens } = useDesignTokens();
    const { tooltip, slider } = tokens;

    return [
      css`
        min-width: ${slider.tooltip.minWidth};
        border-radius: ${tooltip.radius};
        padding-top: ${tooltip.padding.top};
        padding-bottom: ${tooltip.padding.bottom};
        padding-left: ${tooltip.padding.left};
        padding-right: ${tooltip.padding.right.default};
        background: ${tooltip.backgroundColor};
        z-index: ${tooltip.zIndex};
        position: relative;
        display: flex;
        justify-content: center;
        text-align: left;
      `,
      $isHidden &&
        css`
          visibility: hidden;
        `,
    ];
  }}
`;
